import { Component, OnInit } from '@angular/core';
import { MovieModel } from 'src/app/core/interfaces/movie.model';
import { ParameterModel } from 'src/app/core/interfaces/parameter.model';
import { CategoriesService } from 'src/app/core/services/categories.service';
import { ParametersService } from 'src/app/core/services/parameters.service';

@Component({
  selector: 'app-filmic-archive',
  templateUrl: './filmic-archive.component.html',
  styleUrls: ['./filmic-archive.component.css'],
})
export class FilmicArchiveComponent implements OnInit {
  PARAMS: ParameterModel;
  movies: MovieModel[] = [];
  loading = false;

  constructor(private parametersService: ParametersService, private categoriesService: CategoriesService) { }

  async ngOnInit() {
    this.PARAMS = await this.parametersService.getAllParameters();

    this.loading = true;

    this.categoriesService.getCategoryByIdWithMovies(this.PARAMS.FILM_ARCHIVE_ID.value).subscribe(
      (resp) => {
        this.loading = false;

        this.movies = resp[0].movies;
      },
      (error) => {
        this.loading = false;
      },
    );
  }
}
